export enum ApyFilterEnum {
  ALL = "all",
  P5 = "5",
  P10 = "10",
  P25 = "25",
  P50 = "50",
  P100 = "100",
  P500 = "500",
}
